import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';

const PROMO_URL =
  'https://bookings.cloud.microsoft/book/PositivFitnessWolnzach@positivwolnzach.onmicrosoft.com/s/9TnjNs5VxU-nEjUieOssKA2?ismsaljsauthenabled=true';

// Aktion gilt nur am Freitag, 23.10.2026 - danach wird das Popup nicht mehr angezeigt
const PROMO_END = new Date('2026-10-24T00:00:00+02:00');
const STORAGE_KEY = 'goldenFridayPopupSeen';

const PromoPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (Date.now() >= PROMO_END.getTime()) return;
    try {
      // Pro Browser-Sitzung nur einmal anzeigen
      if (sessionStorage.getItem(STORAGE_KEY)) return;
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
      // sessionStorage nicht verfügbar - Popup trotzdem zeigen
    }
    const timer = setTimeout(() => setOpen(true), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-[92vw] max-w-[520px] p-0 border-0 bg-transparent gap-0 overflow-hidden rounded-lg [&>button]:z-10 [&>button]:right-3 [&>button]:top-3 [&>button]:rounded-full [&>button]:bg-black/70 [&>button]:p-2 [&>button]:text-white [&>button]:opacity-100">
        <DialogTitle className="sr-only">Golden Friday bei POSITIV Wolnzach</DialogTitle>
        <DialogDescription className="sr-only">
          Nur am Freitag, 23.10.: Gratis trainieren bis Silvester, danach 30 Wochen 30 % Rabatt.
        </DialogDescription>
        <a href={PROMO_URL} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)}>
          <img
            src="/images/golden-friday.jpg"
            alt="Golden Friday: Gratis trainieren bis Silvester. Danach 30 Wochen 30 % Rabatt. Jetzt Termin buchen"
            className="w-full h-auto block"
          />
        </a>
      </DialogContent>
    </Dialog>
  );
};

export default PromoPopup;
